import {
  EUserRoles,
  ERouterNames,
  TRequiredUserField,
  TCommunicationChannel,
} from '@/types';

export const languageOptions = [
  { id: 'en', title: 'English', image: '/images/countries/us.png' },
  { id: 'es', title: 'Spanish', image: '/images/countries/es.png' },
  { id: 'pt', title: 'Portuguese', image: '/images/countries/br.png' },
];

export const GENDERS = [
  { id: 'male', title: 'Male' },
  { id: 'female', title: 'Female' },
];

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_COLORS = {
  primary100: '#eaf2fe',
  primary200: '#e7f4fe',
  primary300: '#cadbf4',
  primary500: '#5f9fea',
  primary600: '#3476d8',
  primary700: '#144693',
  accent: '#144693',
  buttonText: '#ffffff',
};

export const DIFFERENT_COLORS = [
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#ff7300',
  '#ff4d4f',
  '#4db6ac',
  '#9575cd',
  '#4fc3f7',
];

export const START_DATE_FOR_REPORTS = '2024-07-01T00:00:00.000Z';

export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'svg', 'png'];

// Query param with the id of the Encounter's appointment, so the page can
// fetch it after a reload when the user can't load the appointments list.
export const ENCOUNTER_APPOINTMENT_ID_PARAM = 'appointment_id';

export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  OPEN_ON_DEMAND: 'openOnDemand',
  CURRENT_INSTITUTION_ID: 'currentInstitutionId',
  INFERMEDICA_TOKEN: 'infermedica_token',
  INFERMEDICA_REFRESH_TOKEN: 'infermedica_refresh_token',
  PAYMENT_REDIRECT: 'payment-redirect',
  KIOSK_TOKEN: 'kioskToken',
  KIOSK_ID: 'kioskId',
  LOGIN_SOURCE: 'login',
};

export const SESSION_STORAGE_KEYS = {
  // redirectPath for redirect after login (save path)
  REDIRECT_PATH: 'redirectPath',
};

export const PER_PAGE = 8;

export const ALLOWED_FILE_TYPES = '.jpg, .jpeg, .png, .pdf, .heic';

export const MAX_FILE_SIZE = 25 * 1024 * 1024;

/**
 * Template ID for legacy visit notes (old 4-field format: subjective, objective, assessment, plan)
 */
export const SYSTEM_ID = '00000000-0000-0000-0000-000000000000';

export const homepageByRole = {
  [EUserRoles.ADMIN]: ERouterNames.USERS_TABLE,
  [EUserRoles.COORDINATOR]: ERouterNames.DASHBOARD,
  [EUserRoles.PROVIDER]: ERouterNames.DASHBOARD,
  [EUserRoles.GUEST]: ERouterNames.DASHBOARD,
  [EUserRoles.PATIENT]: ERouterNames.DASHBOARD,
  [EUserRoles.DEVICE]: ERouterNames.DASHBOARD,
  [EUserRoles.PRESENTER]: ERouterNames.DASHBOARD,
};
export const requiredPatientFieldPath: Record<string, TRequiredUserField> = {
  dob: 'dob',
  gender: 'gender',
  taxId: 'meta.taxId',
  policyNumber: 'meta.insurance.policyNumber',
  insurance: 'meta.insurance.name',
  phone: 'phone',
  insuranceCardPhoto: 'meta.insuranceCardPhoto',
  photoId: 'meta.photoId',
};

export const requiredProviderFieldPath: Record<string, TRequiredUserField> = {
  phone: 'phone',
};

export const requiredProviderLocationFields: TRequiredUserField[] = [
  'userLocation.country',
  'userLocation.state',
  'userLocation.city',
  'userLocation.zip',
  'userLocation.address1',
  'userLocation.address2',
];

export const COMMUNICATION_CHANNEL_ICONS: Record<
  TCommunicationChannel,
  'Video' | 'Messages'
> = {
  video: 'Video',
  chat: 'Messages',
};

export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = 24 * MINUTES_IN_HOUR;
export const INPUT_MAX_VALUE = '99999';

/**
 * Minimum age threshold for requiring height and weight fields for patients.
 * Used for DoseSpot integration.
 */
export const PATIENT_MIN_AGE_FOR_HEIGHT_WEIGHT_REQUIRED = 19;

/**
 * Name of the system service the BE auto-creates for Presenter appointments.
 * It must stay hidden from the Admin Panel and regular scheduling flows.
 */
export const MEDWAND_SERVICE_NAME = 'MedWand';
